module.exports = __webpack_public_path__ + "images/questions/qa_check_674310f68f3fa620fbb8a02f74726f20.png";